import { Tag } from "./Tag";
import { TagType } from "./ TagType";

export enum  LookaheadTagStatus {
    Todo='Todo',
    WorkingOn='Working On',
    Done='Done',
    DoneDone='Done Done'
}
export interface LookaheadTag extends Tag {
    name: string,
    tradeId: string,
    locationId: string,
    predecessorId?: string,
    crewSize: number,
    constraintId?: string,
    tagDate?: string
    goal?: string,
    status: LookaheadTagStatus;
    tagCardType?: TagType
    indexId: string | number | null,
    isMilestone?: boolean | undefined,
}



// WEBPACK FOOTER //
// ./src/models/LookaheadTag.ts